// extracted by mini-css-extract-plugin
export default {"home":"style_home__sPuK0","container":"style_container__+wUbq","cardsTop":"style_cardsTop__aIVDF","basliq":"style_basliq__Fv2Vx","homeLeftxx":"style_homeLeftxx__irnxH"};